import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Badge } from "@mui/material";
import {
  FiCalendar, FiFileText, FiBook, FiUser, FiLogIn, FiLogOut, FiBookOpen, FiClock, FiMenu, FiX, FiFolder, FiRss,
} from "react-icons/fi";
import logo from "../../logo.svg";
import axios from "axios";
import utils from "../../utils";

const Nav = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [newsCount, setNewsCount] = useState(0); // Stato per il conteggio delle notizie

  const userType = sessionStorage.getItem("usertype") || localStorage.getItem("usertype");

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    if (!menuOpen) {
      document.body.classList.add("menu-open");
      document.body.style.overflow = "hidden";
    } else {
      document.body.classList.remove("menu-open");
      document.body.style.overflow = "auto";
    }
  };

  const handleLinkClick = () => {
    setMenuOpen(false);
    document.body.classList.remove("menu-open");
    document.body.style.overflow = "auto";
  };

  const handleScroll = () => {
    setScrolled(window.scrollY > 50);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.body.classList.remove("menu-open");
      document.body.style.overflow = "auto";
    };
  }, []);

  const clearLocalStorage = () => {
    localStorage.removeItem('jwt');
    localStorage.removeItem('dipendente');
    localStorage.removeItem('usertype');
    // finche non attivano o rifiutano
    localStorage.removeItem('notificationReminderShown');
  }

  const logout = async () => {
    try {
      if (userType === "dip") {
        sessionStorage.clear();
        clearLocalStorage();
        window.location.href = "/";
      } else {
        const res = await axios.post(
          "/api/logout",
          {},
          { headers: utils.getAuthHeaders(), validateStatus: () => true }
        );
        if (res.status === 200 && res.data.success) {
          sessionStorage.clear();
          clearLocalStorage();
          window.location.href = "/";
        } else if (res.data.error) {
          console.log(res.data.error);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchNewsCount = async () => {
    try {
      const res = await axios.get("/api/newsclientinuove", {
        headers: utils.getAuthHeaders(),
        validateStatus: () => true,
      });
      if (res.status === 200 && res.data.success) {
        setNewsCount(res.data.count); // Imposta il numero delle notizie
      }
    } catch (_) {
      console.error("Error fetching news count");
    }
  };

  useEffect(() => {
    fetchNewsCount(); // Chiamata per ottenere il numero delle notizie
  }, []);

  return (
    <>
      <style>{`
        #root, .app-container {
          overflow-x: hidden;
          width: 100%;
        }

        .navbar, .navbar * {
          box-sizing: border-box;
          max-width: 100%;
        }

        .navbar {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background-color: rgba(29, 29, 29, 0.95);
          padding: 12px 24px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          position: sticky;
          top: 0;
          z-index: 1000;
          width: 100%;
        }

        .brand {
          display: flex;
          align-items: center;
        }

        .brand img {
          max-height: 45px;
          transition: transform 0.3s ease;
        }

        .brand:hover img {
          transform: scale(1.05);
        }

        .nav-links {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .nav-link {
          display: flex;
          align-items: center;
          color: #f2f2f2;
          text-decoration: none;
          padding: 8px 12px;
          border-radius: 6px;
          font-family: "Segoe UI", "Roboto", sans-serif;
          font-weight: 500;
          font-size: 15px;
          transition: all 0.2s ease;
          position: relative;
          white-space: nowrap;
        }

        .nav-link:after {
          content: '';
          position: absolute;
          width: 0;
          height: 2px;
          bottom: 0;
          left: 50%;
          background-color: #3498db;
          transition: all 0.3s ease;
        }

        .nav-link:hover {
          color: #3498db;
          background-color: rgba(255, 255, 255, 0.05);
        }

        .nav-link:hover:after {
          width: 80%;
          left: 10%;
        }

        .nav-link.logout:hover {
          color: #e74c3c;
        }

        .nav-link.logout:hover:after {
          background-color: #e74c3c;
        }

        .nav-icon {
          margin-right: 8px;
          font-size: 18px;
        }

        .login {
          background-color: rgba(52, 152, 219, 0.2);
          border: 1px solid rgba(52, 152, 219, 0.5);
          padding: 8px 16px;
          margin-left: 8px;
        }

        .login:hover {
          background-color: rgba(52, 152, 219, 0.3);
        }

        .hamburger-menu {
          display: none;
          cursor: pointer;
          color: #fff;
          padding: 8px;
          border-radius: 4px;
          transition: background-color 0.3s ease;
        }

        .hamburger-menu:hover {
          background-color: rgba(255, 255, 255, 0.1);
        }

        @media (max-width: 1024px) {
          .navbar {
            padding: 12px 16px;
          }

          .nav-links {
            position: absolute;
            top: 100%;
            left: 0;
            width: 100%;
            background-color: #1d1d1d;
            box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
            flex-direction: column;
            padding: 16px 0;
            z-index: 999;
            opacity: 0;
            visibility: hidden;
            transition: opacity 0.3s ease, visibility 0.3s ease;
            height: 0;
            overflow: hidden;
          }

          .nav-links.open {
            opacity: 1;
            visibility: visible;
            height: auto;
            max-height: calc(100vh - 70px);
            overflow-y: auto;
          }

          .nav-link {
            width: 90%;
            margin: 4px auto;
            padding: 12px 16px;
            justify-content: flex-start;
          }

          .nav-icon {
            font-size: 20px;
            margin-right: 12px;
          }

          .login {
            width: 90%;
            margin: 4px auto;
          }

          .hamburger-menu {
            display: flex;
            align-items: center;
            justify-content: center;
          }

          @keyframes fadeDown {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }

            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .nav-links.open .nav-link {
            animation: fadeDown 0.3s ease forwards;
            animation-delay: calc(var(--item-index, 0) * 0.05s);
          }

          body::after {
            content: '';
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0);
            z-index: -1;
            transition: background-color 0.3s ease;
            pointer-events: none;
          }

          body.menu-open::after {
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 998;
            pointer-events: auto;
          }
        }
      `}</style>

      <nav className={`navbar ${scrolled ? "scrolled" : ""}`} id="navbar-item">
        <div className="brand">
          <Link to="/" onClick={handleLinkClick}>
            <img src={logo} alt="Logo" />
          </Link>
        </div>

        <div className={`nav-links ${menuOpen ? "open" : ""}`}>
          <Link to="/filemanager" onClick={handleLinkClick} className="nav-link">
            <FiFolder className="nav-icon" />
            <span>File Manager</span>
          </Link>
          {userType === "op" && (
            <Link to="/formazione" onClick={handleLinkClick} className="nav-link">
              <FiBookOpen className="nav-icon" />
              <span>Formazione</span>
            </Link>
          )}

          {userType === "user" && (
            <Link to="/cli/news" onClick={handleLinkClick} className="nav-link">
              <FiRss className="nav-icon" />
              <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
                Circolari
                {newsCount > 0 && (
                  <Badge
                    badgeContent={newsCount}
                    color="error"
                    sx={{
                      position: 'absolute',
                      top: '-2px',
                      right: '-10px',
                    }}
                  />
                )}
              </span>
            </Link>
          )}

          <Link to="/scadenze" onClick={handleLinkClick} className="nav-link">
            <FiCalendar className="nav-icon" />
            <span>Scadenze</span>
          </Link>
          <Link to="/moduli" onClick={handleLinkClick} className="nav-link">
            <FiFileText className="nav-icon" />
            <span>Moduli</span>
          </Link>
          <Link to="/blog" onClick={handleLinkClick} className="nav-link">
            <FiBook className="nav-icon" />
            <span>Blog</span>
          </Link>
          {userType === "op" && (
            <Link to="/op" onClick={handleLinkClick} className="nav-link">
              <FiUser className="nav-icon" />
              <span>Area Op</span>
            </Link>
          )}
          {userType === "user" && (
            <Link to="/cli" onClick={handleLinkClick} className="nav-link">
              <FiUser className="nav-icon" />
              <span>Area Clienti</span>
            </Link>
          )}
          {userType === "dip" && (
            <Link to="/dip" onClick={handleLinkClick} className="nav-link">
              <FiUser className="nav-icon" />
              <span>Area Dipendenti</span>
            </Link>
          )}
          {userType ? (
            <Link onClick={logout} className="nav-link logout">
              <FiLogOut className="nav-icon" />
              <span>Logout</span>
            </Link>
          ) : (
            <>
              <Link to="/logindipendenti" onClick={handleLinkClick} className="nav-link">
                <FiClock className="nav-icon" />
                <span>Timbratore</span>
              </Link>
              <Link to="/login" onClick={handleLinkClick} className="nav-link login">
                <FiLogIn className="nav-icon" />
                <span>Login</span>
              </Link>
            </>
          )}
        </div>

        <div className="hamburger-menu" onClick={toggleMenu}>
          {menuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </div>
      </nav>
    </>
  );
};

export default Nav;
